import Spinner from "components/Spinner";
import React from "react";

const LoadingComponent = ({ loading, children }) => {
  return <>{loading ? <Spinner loading={loading} /> : children}</>;
};

export default LoadingComponent;
